import { PieChartTooltipProps } from '@shared/models/charts/pie-chart.model.ts';

const PieChartTooltip = ({
  active,
  payload,
  showCount,
  valueFormatter,
  tooltipValueLabel,
  t
}: PieChartTooltipProps) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    const formattedValue = valueFormatter
      ? valueFormatter(data.value)
      : `$${data.value.toLocaleString()}`;

    const label = tooltipValueLabel && t ? t(tooltipValueLabel) : 'orders';

    return (
      <div
        className="bg-(--white) rounded-lg px-3 py-2"
        style={{
          boxShadow: '0 4px 12px var(--black-alpha-150)'
        }}
      >
        <div className="flex items-center gap-2 mb-1">
          <div
            className="w-2.5 h-2.5 rounded-full"
            style={{ backgroundColor: data.color }}
          />
          <span className="text-base text-(--dark-2)">{data.name}</span>
        </div>
        <div className="text-base text-(--blue-4)">
          {showCount
            ? `${data.count} ${label} · ${formattedValue}`
            : formattedValue}
        </div>
      </div>
    );
  }

  return null;
};

export default PieChartTooltip;
